import { tv } from "@/lib/tailwind-variants";

export const iconButtonVariants = tv({
  base: "ring-offset-background inline-flex items-center justify-center border text-xl leading-none transition-colors focus-visible:border-info-500 focus-visible:ring-2 focus-visible:ring-info-500/50 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-300",
  variants: {
    variant: {
      primary:
        "border-transparent bg-primary text-white hover:bg-primary-600 [&]:hover:text-white",
      secondary:
        "border-primary bg-white text-primary hover:bg-primary-100 [&]:hover:text-primary",
      gray: "border-gray-300 bg-gray-100 text-gray-600 hover:bg-gray-200 [&]:hover:text-gray-600",
      noBgPrimary:
        "border-transparent bg-transparent text-primary hover:bg-primary-100 [&]:hover:text-primary",
      noBgGray:
        "border-transparent bg-transparent text-gray-600 hover:bg-gray-200 [&]:hover:text-gray-600",
    },
    size: {
      medium: "h-[34px] w-[34px]",
      small: "h-[26px] w-[26px]",
    },
    isRound: {
      true: "rounded-full",
      false: "rounded-sm",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "medium",
    isRound: false,
  },
});
